import { createElement } from 'react'
import { DeleteBankAccount } from './components'

export const createColumnsBankAccount = () => [
  {
    Header: 'Account number',
    accessor: 'accountNumber',
  },
  {
    Header: 'Bank name',
    accessor: 'bankName',
  },
  {
    Header: 'Currency',
    accessor: 'currency',
  },
  {
    Header: 'Iban',
    accessor: 'iban',
  },
  {
    Header: 'Bank Account Name',
    accessor: 'displayName',
  },
  {
    Header: 'MemberId',
    accessor: 'memberId',
  },
  {
    Header: 'Delete',
    id: 'controls',
    accessor: (value) => value,
    Cell: (props) => createElement(DeleteBankAccount, { ...props }),
  },
]
